<template>
   
  <div class="home">
    <App-navigation></App-navigation>
  
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
              Available  tickets refreshments
                           </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="specific()" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}">
                  <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.name.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.ref_name.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.quantity }}</td>
                  <td class="text-xs-center">{{item.price}}</td>
                  <td class="text-xs-center">{{item.amount}}</td>
                  <td class="text-xs-center">{{item.usersold.toUpperCase() }}</td>
                 <td class="text-xs-center">{{item.dateadded}}</td>
                  <td class="justify-center layout px-0">
                  <Delete-ticket v-if="crc(staff.rights,'015')" :name="item.name"></Delete-ticket>
                  </td>
                </template>
              </v-data-table>

            </v-flex>
        </v-layout>
     </v-container>
     
     
  </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import DeleteTicket from '@/components/Ticket/DeleteTicket.vue'
import {checkright,specify} from '@/validator'
export default {
  name: 'ticket-refreshment',
  data(){
      return {
         // staff:{name:'Okoedo',gender:''},
            
          staff:this.$store.getters.getStaff,
          dialog:false,
          search:'',
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'Ticket ID',
              align:'center',
              sortable:true,
              value:'name'
            },
            {
              text:'NAME',
              align:'center',
              sortable:true,
              value:'ref_name'
            }, 
            {
              text:'QUANTITY',
              align:'center',
              sortable:true,
              value:'quantity'
            },
            {
              text:'PRICE(N)',
              align:'center',
              sortable:true,
              value:'price'
            },
            
            {
              text:'AMOUNT(N)',
              align:'center',
              sortable:true,
              value:'amount'
            },
             {
              text:'SOLD BY',
              align:'center',
              sortable:true,
              value:'usersold'
            },
             {
              text:'DATE SOLD',
              align:'center',
              sortable:true,
              value:'dateadded'
            },
            {
              text:'ACTIONS',
              sortable:false,
             
            }
          ],
          listPrimitive:null
      }
  },
  methods:{
      specific(){
        return specify(this.loads(),'type','refreshment');
      },
         loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateTickets');
            value = self.$store.getters.getTicket;
            //console.log(value);
            return value;
           
            
        },
    crc(array,value){
      return checkright(array,value);
    },
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation:AppNavigation,
    DeleteTicket:DeleteTicket,

  }
}
</script>
